import subscriptionsTotalWidgetTemplate from './subscriptionsTotalWidget.html';
import './subscriptionsTotalWidget.scss';

export default angular
  .module('main.dashboardPanel.subscriptionsTotalWidget', [])

  .directive('subscriptionsTotalWidget', () => {
    return {
      restrict: 'E',
      template: subscriptionsTotalWidgetTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   DashboardDataProvider) => {
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getSubscriptionsLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              const subscriptionIds = reportInfo.dictionary
                .filter(si => si.id !== 0) // except "No Subscription" entry (always have id=0). Btw id here is actual subscription id.
                .map(si => JSON.stringify(si.id));
              // NOTE sometimes `id` in `dictionary[].id` and `id` in `executions[].data[].id` may have different format (string/number).
              //  We should report such cases to Oleg

              let executions = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  ...execution,
                  total: execution.data?.reduce((acc, e) =>
                    subscriptionIds.includes(JSON.stringify(e.id))
                      ? acc + parseInt(e.value)
                      : acc, 0) || 0
                }));

              let lastExecution = executions[executions.length - 1];
              if (!lastExecution.data) {
                $scope.noData = true;
                return;
              }

              $scope.trend = DashboardDataProvider.calculateTrend(executions, 'total');
              $scope.trendDate = new Date(executions[0].executionDateMs);
              $scope.subscriptionsTotal = lastExecution.total;
            }, (err) => {
              utils.handleApiError(err);
              $scope.noData = true;
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
